import { Outlet } from "react-router-dom";
import "./Layout.css"
import Navigation from "../navigation/Navigation";
import useUser from "../../hooks/useUser";




//TODO check auto logout
//TODO INVALID cache at job timing


export default function Layout({sideNav: isOpen, setSideNav: setSideNavState, gbSearch: gbSearch }) {
    const {isLoggedIn}=useUser();
    
    return (
        <main id="layoutDiv" className={isLoggedIn?"mainLayout":"mainLayout login"} >
            <section style={isLoggedIn?{}:{'display':"none"}} className={isOpen?"mainLayout__NavBar active":"mainLayout__NavBar"} >
                <Navigation isOpen={isOpen} toggleDrawer={setSideNavState} gbSearch={gbSearch} />
                <div className={isOpen?"backdrop backdrop--show":"backdrop"} style={{position:"absolute"}} onClick={() => { setSideNavState(false) }} ></div>
            </section>
            <section id="mainLayout__Outlet" className="mainLayout__Outlet" >
                <Outlet />
            </section>
        </main>
    )
}